import config from "../../../config";

const headers = {
  "content-type": "application/json",
  "x-app-id": "1be5353c-723e-48fb-aef3-d095ece2aa32",
  "x-app-version": 270,
  pragma: "no-cache",
  "cache-control": "no-cache",
};

const fetchFromLibraryApi = async (url, options = {}) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.accessToken) {
    headers.authorization = user.accessToken;
  }

  return fetch(`${config.apiUrl}${url}`, {
    ...options,
    headers,
  });
};

export const getLibraryPlaylists = () =>
  fetchFromLibraryApi("/library/playlists").then(async (result) => {
    const data = await result.json().catch(() => ({}));
    if (!result.ok) {
      return Promise.reject(
        data?.message || "Failed to load library playlists."
      );
    }
    return data;
  });

export const createLibraryPlaylist = (body) =>
  fetchFromLibraryApi("/library/playlists", {
    method: "post",
    body: JSON.stringify(body),
  }).then(async (result) => {
    const data = await result.json().catch(() => ({}));
    if (!result.ok) {
      return Promise.reject(
        data?.message || "Failed to create library playlist."
      );
    }
    return data;
  });

export const updateLibraryPlaylist = (playlistId, body) =>
  fetchFromLibraryApi(`/library/playlists/${playlistId}`, {
    method: "put",
    body: JSON.stringify(body),
  }).then(async (result) => {
    const data = await result.json().catch(() => ({}));
    if (!result.ok) {
      return Promise.reject(
        data?.message || "Failed to update library playlist."
      );
    }
    return data;
  });

export const deleteLibraryPlaylist = (playlistId) =>
  fetchFromLibraryApi(`/library/playlists/${playlistId}`, {
    method: "delete",
  }).then(async (result) => {
    const data = await result.json().catch(() => ({}));
    if (!result.ok) {
      return Promise.reject(
        data?.message || "Failed to delete library playlist."
      );
    }
    return data;
  });
